module.exports = __webpack_public_path__ + "eb5d11b7575b298ace307fa9c8a59fe6.MP3";